// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfileSideBar_wrapper__wUdH8"};